import moment from "moment";
import { getDefaultSelectedDate } from "../../utilities/dateUtils";

const { initialStartDate, initialEndDate } = getDefaultSelectedDate();

export const initialDateSettings = {
  timePicker: false,
  maxDate: moment().toDate(),
  autoApply: true,
  startDate: initialStartDate.toMillis(),
  endDate: initialEndDate.toMillis(),
  locale: {
    format: "DD/MM/YYYY",
  },
};
export const clearedFilters = {
  selectedApplication: [],
  selectedProject: [],
  selectedSprint: [],
  selectedDepartment: [],
  selectedDivision: [],
  selectedDate: initialDateSettings,
};
